import React, { forwardRef } from "react"
import { useURLSorterState } from "@/core/hooks"
import BaseTable from "./BaseTable"
import { getNextSortState } from "@/utilities"

const AtomicTable = (props, fwfRef) => {
    const [sorter, setSorter] = useURLSorterState()

    const handleSorting = (key) => setSorter(getNextSortState(sorter, key))

    return <BaseTable {...props} ref={fwfRef} sorter={sorter} onSort={handleSorting} />
}

export default forwardRef(AtomicTable)
